module.exports = __webpack_public_path__ + "img/model1.5d6902e6.png";